import * as React from 'react';
import { useServiceOrderStatusTypeOptions } from 'hooks/api/options';
import type { CheckboxesConfig } from 'components/ui/page-header-with-checkboxes';

export const usePageHeaderConfig = () => {
  const statusOptions = useServiceOrderStatusTypeOptions({
    valueType: 'slug',
  });

  const checkboxesConfig = React.useMemo((): CheckboxesConfig => {
    return {
      options: statusOptions.multiSelectOptions,
      defaultSelected: statusOptions.singleSelectOptions.map((option) => option.value),
    };
  }, [statusOptions]);

  return {
    checkboxesConfig,
    loadingConfig: statusOptions.loading
  };
};